module.exports = __webpack_public_path__ + "img/purchases_report.83c1267d.png";